/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { ShaderFullscreen } from './InteractiveComponents';
export const metadata = {
  demo: ShaderFullscreen,
  title: 'Shaders'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Shaders are little programs run on the GPU. In WebGL, they use a language called GLSL, that is a little closer to C or C++ than it is to JavaScript.`}</p>
    <p>{`The demo below shows a full-screen `}<em parentName="p">{`fragment`}</em>{` shader. We will also be learning about `}<em parentName="p">{`vertex`}</em>{` shaders.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
